import { Grid, Divider, H, P } from '@farewill/ui'
import { useSelector } from 'react-redux'

import { ProbateCase } from 'lib/models/probate-case'
import { LAW_FIRM_NAMES } from 'utils/enums'

import LostOrDeclined from './lost-or-declined'
import CaseDetailsSummary from './case-details-summary'
import Price from './price'
import Ownership from './ownership'
import { Pricing } from './pricing'
import CreateProbateCustomerAccount from './create-probate-customer-account'
import { ContactContextProvider } from 'routes/contact/context'
import ENV from 'config/environment'

const CaseDetails = () => {
  const probateCase: ProbateCase = useSelector(
    (state: { probateCase: ProbateCase }) => state.probateCase
  )
  const { attributes } = probateCase
  return (
    <Grid>
      <Grid.Item>
        <H size="M">Case overview</H>
      </Grid.Item>
      <CaseDetailsSummary probateCase={attributes} />
      <Ownership />
      <Grid.Item margin={['XS', 0]}>
        <Divider />
      </Grid.Item>
      {ENV.FF_COGNITO_AUTH_LOG_IN && (
        <ContactContextProvider contactId={attributes.contact.id}>
          <CreateProbateCustomerAccount probateCase={probateCase} />
        </ContactContextProvider>
      )}
      <Grid.Item>
        <H size="S">Booking</H>
      </Grid.Item>
      <Grid.Item>
        <P margin={[0, 0, 'XS']}>
          Referred to:{' '}
          <strong>
            {attributes.referredTo
              ? LAW_FIRM_NAMES[attributes.referredTo] || attributes.referredTo
              : 'Not yet referred'}
          </strong>
        </P>
        <Price />
      </Grid.Item>
      <Grid.Item margin={['XS', 0]}>
        <Divider />
      </Grid.Item>
      <Grid.Item>
        <H size="S">Pricing</H>
      </Grid.Item>
      <Grid.Item>
        <Pricing />
      </Grid.Item>
      <LostOrDeclined />
    </Grid>
  )
}

export default CaseDetails
